export default [
  {
    path: '/marketing',
    component: '@/pages/marketing/layouts/index',
    routes: [
      {
        path: './Videos',
        component: '@/pages/marketing/pages/Videos/index',
      },
      {
        path: './Hashtag',
        component: '@/pages/marketing/pages/Hashtag/index',
      },
      {
        path: './Hashtag/Details',
        component: '@/pages/marketing/pages/Hashtag/Details/index',
      },
      {
        path: './Memes',
        component: '@/pages/marketing/pages/Memes/index',
      },
      {
        path: './Memes/Details',
        component: '@/pages/marketing/pages/Memes/Details/index',
      },
      {
        path: './Download',
        component: '@/pages/marketing/pages/Download/index',
      },
      {
        path: './CompetitorsAdCreatives',
        component: '@/pages/marketing/pages/CompetitorsAdCreatives/index',
      },
      {
        path: './CompetitorAdComparison',
        component: '@/pages/marketing/pages/CompetitorAdComparison/index',
      },
      {
        path: './CreativeTrends',
        component: '@/pages/marketing/pages/CreativeTrends/index',
      },
      {
        path: './CreativeTrends/Details',
        component: '@/pages/marketing/pages/CreativeTrends/Details/index',
      },
      {
        path: './UgcCreativeTrends',
        component: '@/pages/marketing/pages/UgcCreativeTrends/index',
      },
      {
        path: './UgcCreativeTrends/Details',
        component: '@/pages/marketing/pages/UgcCreativeTrends/Details/index',
      },
      {
        path: './MahjongSolitaire/TopCreatives',
        component: '@/pages/marketing/pages/ZoneTopCreatives/index',
      },
      {
        path: './Arrows/TopCreatives',
        component: '@/pages/marketing/pages/ZoneTopCreatives/index',
      },
      {
        path: './MahjongSolitaire/TrendingPublications',
        component: '@/pages/marketing/pages/ZoneTrendingPublications/index',
      },
      {
        path: './Arrows/TrendingPublications',
        component: '@/pages/marketing/pages/ZoneTrendingPublications/index',
      },
      {
        path: './Merge2/TopCreatives',
        component: '@/pages/marketing/pages/ZoneTopCreatives/index',
      },
      {
        path: './Merge2/TrendingPublications',
        component: '@/pages/marketing/pages/ZoneTrendingPublications/index',
      },
      {
        path: './Merge3/TopCreatives',
        component: '@/pages/marketing/pages/ZoneTopCreatives/index',
      },
      {
        path: './Merge3/TrendingPublications',
        component: '@/pages/marketing/pages/ZoneTrendingPublications/index',
      },
    ],
  },
];
